import { useEffect, useState } from 'react';
import style from './Payment.module.css';

const initialPaymentOptions = [
    { id: 'liqpay', desc: 'Liqpay' },
    { id: 'cash', desc: 'Готівка' },
    { id: 'account', desc: 'Рахунок' },
    { id: 'card', desc: 'Картка' },
];

// function Payment({ handleFormChange, clientSelected, currentPayment }) {
//     const [selectedOption, setSelectedOption] = useState(initialPaymentOptions[clientSelected ? 0 : 1].id);
//     const [paymentOptions, setPaymentOptions] = useState([]);

//     useEffect(() => {
//         if (clientSelected) setPaymentOptions(initialPaymentOptions);
//         else setPaymentOptions(initialPaymentOptions.filter((item) => item.id !== 'liqpay'));
//     }, [clientSelected]);

//     const handleChange = (event) => {
//         const { value } = event.target;
//         setSelectedOption(value);
//         handleFormChange(event);
//     };

//     return (
//         <div className={style.container}>
//             <h3 className={style.title}>Оберіть спосіб оплати</h3>
//             <div className={style.paymentOptions}>
//                 {paymentOptions.map(({ id, desc }) => (
//                     <div className={style.paymentOption} key={id}>
//                         <input
//                             type="radio"
//                             id={id}
//                             name="payment"
//                             value={id}
//                             checked={selectedOption === id}
//                             onChange={handleChange}
//                             className={style.radioInput}
//                         />
//                         <label htmlFor={id} className={style.radioLabel}>
//                             {desc}
//                         </label>
//                     </div>
//                 ))}
//             </div>
//         </div>
//     );
// }

// export default Payment;

function Payment({ handleFormChange, clientSelected, currentPayment }) {
    const [paymentOptions, setPaymentOptions] = useState([]);

    useEffect(() => {
        if (clientSelected) setPaymentOptions(initialPaymentOptions);
        else setPaymentOptions(initialPaymentOptions.filter((item) => item.id !== 'liqpay'));
    }, [clientSelected]);

    return (
        <div className={style.container}>
            <h3 className={style.title}>Оберіть спосіб оплати</h3>
            <div className={style.paymentOptions}>
                {paymentOptions.map(({ id, desc }) => (
                    <div className={style.paymentOption} key={id}>
                        <input
                            type="radio"
                            id={id}
                            name="payment"
                            value={id}
                            checked={currentPayment === id}
                            onChange={handleFormChange}
                            className={style.radioInput}
                        />
                        <label htmlFor={id} className={style.radioLabel}>
                            {desc}
                        </label>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Payment;
